import { render, staticRenderFns } from "./NewsPostIndex.vue?vue&type=template&id=13f03b21"
import script from "./NewsPostIndex.vue?vue&type=script&lang=js"
export * from "./NewsPostIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports